import { gql, permitFields } from 'providers/tanstack-query/utils'

import type { Data, Variables } from './types'
import type { Ability } from 'providers/casl'
import type { TypedDocumentNode } from 'providers/tanstack-query/types'

export const GET_RICH_PLACEMENT_K_WORDS = (
  ability: Ability,
): TypedDocumentNode<Data, Variables> => gql`
  query getRichPlacementKWords($workspaceId: ID!) {
    workspaceRichPlacementKwordsConfiguration(workspaceId: $workspaceId) {
      ${permitFields<Data['workspaceRichPlacementKwordsConfiguration']>({
        kwordsSiteId: ability.can('read', 'GlobalSetupField-kWordsSiteId'),
      })}

      id
    }
  }
`
